var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#26008A;stroke:#26008A;stroke-width:2;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,1.5C12,1.5,1.2,12.2,1.2,25.4S12,49.2,25.2,49.2c4.7,0,9.3-1.4,13.2-4l12.2,12.1c1.8,1.8,4.8,1.8,6.7,0 c1.8-1.8,1.8-4.7,0-6.7c-0.2-0.2-0.3-0.3-0.5-0.4l-13.2-9.7c8.5-10.1,7-25.1-3-33.5C36.2,3.5,30.8,1.5,25.2,1.5z M3.2,25.4 c0-12.1,9.9-21.9,22-21.9s22,9.8,22,21.9s-9.9,21.9-22,21.9S3.2,37.4,3.2,25.4z M55.6,51.8c1.2,0.9,1.5,2.6,0.7,3.9 c-0.1,0.1-0.2,0.2-0.3,0.3c-1.1,1.1-2.8,1.1-4,0l-12-11.9c0.9-0.6,1.6-1.3,2.3-2L55.6,51.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9,40.2c-1.2,0-2.4-0.1-3.6-0.4c-4-1-8.2-3.4-11.7-6.9s-6-7.7-6.9-11.6c-1.1-4.2-0.3-7.9,2.1-10.2l0.7-0.6 c1.3-1.3,3.4-1.3,4.7,0l3.9,3.9c1.3,1.3,1.3,3.3,0,4.6l-2.3,2.3c1.1,1.9,2.6,3.9,4.3,5.6c1.7,1.7,3.7,3.2,5.6,4.3l2.3-2.3 c1.3-1.3,3.4-1.3,4.7,0l0,0l3.9,3.9c1.3,1.3,1.3,3.3,0,4.6l-0.9,0.4C36.9,39.3,34.6,40.2,31.9,40.2z M14.6,11.6 c-0.2,0-0.5,0.1-0.7,0.3l-0.8,0.6c-1.7,1.7-2.3,4.6-1.4,8.1c0.9,3.7,3.1,7.4,6.4,10.6s7,5.5,10.6,6.4c3.5,0.9,6.3,0.3,8.1-1.4 l0.7-0.6c0.3-0.3,0.3-1,0-1.3l-3.9-3.9c-0.3-0.3-1-0.3-1.3,0L29.5,33c-0.3,0.3-0.9,0.4-1.3,0.2c-2.4-1.2-4.8-3-6.9-5.2 s-3.9-4.5-5.2-6.9c-0.2-0.4-0.1-1,0.2-1.3l2.9-2.9c0.3-0.3,0.3-1,0-1.3l-3.9-3.9C15.1,11.7,14.9,11.6,14.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,26.4c-0.7,0-1.2-0.5-1.2-1.2l0,0c0-4.2-3.5-7.7-7.7-7.7c-0.7,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2l0,0 c5.5,0,10,4.4,10,9.9C34.3,25.8,33.7,26.4,33.1,26.4L33.1,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1,26.4c-0.7,0-1.2-0.5-1.2-1.2l0,0c0-6.9-5.6-12.5-12.6-12.5c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2l0,0 c8.2,0,14.8,6.7,14.8,14.8C39.1,25.8,38.7,26.4,38.1,26.4L38.1,26.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAnalysis);
export default __webpack_public_path__ + "static/media/Search_Analysis.d5d71ae8a35c9d676f2600bd4491af71.svg";
export { ForwardRef as ReactComponent };